module.exports = __webpack_public_path__ + "assets/4-mid-market-account-executive-salary.a12faed2.png";